import { el, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import deleteIconString from 'assets/images/delete-icon.svg?raw';

const deleteIcon = stringToSVG(deleteIconString);

class OptionInput {

  constructor(optionsInputControl) {

    this.option = null;
    this.index = null;

    this.optionsInputControl = optionsInputControl;

    this.nameInput = null;

    this.el = el('.option-input-control-main', [
      this.renderNameInput(),
      this.renderDeleteButton()
    ]);

  }

  renderNameInput() {

    this.nameInput = el('input', {
      type: 'text',
      class: 'option-input-control',
      placeholder: 'Option #1',
      onkeyup: this.handleOptionNameChange.bind(this)
    });

    return this.nameInput;

  }

  renderDeleteButton() {

    return el('button', {
      type: 'button',
      class: 'option-input-delete-button',
      onclick: this.handleOptionDeleteButtonClick.bind(this)
    }, [
      deleteIcon.cloneNode(true)
    ]);

  }

  handleOptionNameChange(event) {

    const previousValue = this.previousValue;
    const currentValue = event.target.value;

    if (previousValue === currentValue) {
      return;
    }

    this.previousValue = currentValue;

    this.optionsInputControl.handleOptionChange(this.index, currentValue);
  }

  handleOptionDeleteButtonClick() {

    this.optionsInputControl.handleOptionDeleteButtonClick(this.index);

  }

  updateInput() {

    setAttr(this.nameInput, {
      value: this.option,
      placeholder: `Option #${this.index + 1}`
    });

  }

  update(option, index) {

    this.option = option;
    this.index = index;

    this.updateInput();

  }

}

export default OptionInput;